// extracted by mini-css-extract-plugin
module.exports = {"form":"NewQuestion_form__3WVqH"};